module.exports = "<span class=\"text-capitalize\">\r\n  {{ $ctrl.dictionary[$ctrl.userClass] }}\r\n</span>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-user-class/rw-user-class.html
// module id = 1938
// module chunks = 0